<template>

    <Cmember :curnavkv="curnavkv" :navsub.sync="navsub" :options="c_options" @optionchange="optionchange" @groupupdate="groupup">
        <Cquiz :navsub="navsub" :options="c_myoption" v-if="isload" :grouplist="grouplist"></Cquiz>
    </Cmember>
</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'quizs',
        mixins: [mixinmember],
        components: {
            Cquiz: () => import('@/components/Cquiz')
        },
        data() {
            return {
                curnavkv: 29
            };
        },
        computed: {
            c_options: function () {
                let _options = {
                    'hasoption': true, 'courselev': 2, 'showcourse': 2, 'haskw': true, 'noteng': 1, 'issch': 0, 'hasgroup': 1, 'showschool': true, 'showgroup': true
                };
                return _options;
            },
            c_myoption: function () {
                let _myoption = this.$common.basic.jsonclone(this.myoption);
                _myoption.tk = 1;
                return _myoption;
            }
        }
    }
</script>
